import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Seo from '../components/Seo';
import { Blocks, RichText } from '../components/RichText';
import { guideBySlug } from '../data/guides';
import { guideJsonLd } from '../data/pageSchema';
import NotFoundPage from './NotFoundPage';
import './AreaPage.css';

const GuidePage = () => {
  const { slug } = useParams();
  const guide = guideBySlug(slug);

  if (!guide) return <NotFoundPage />;

  return (
    <div className="area-page">
      <Seo
        title={guide.title}
        description={guide.description}
        path={guide.path}
        jsonLd={guideJsonLd(guide)}
      />
      <header className="area-hero">
        <div className="hero-bg-lines" aria-hidden="true" />
        <div className="area-hero-content">
          <div className="hero-eyebrow">Guide</div>
          <h1>{guide.h1}</h1>
        </div>
      </header>
      <div className="page-wrapper">
        <article className="area-card area-block area-prose">
          <Blocks blocks={guide.blocks} />
        </article>
        {guide.faqs && guide.faqs.length > 0 && (
          <section className="area-block" aria-labelledby="guide-faq-heading">
            <h2 id="guide-faq-heading">Questions</h2>
            <div className="area-faq">
              {guide.faqs.map((faq) => (
                <details key={faq.q} className="area-faq-item">
                  <summary>{faq.q}</summary>
                  <div className="area-answer">
                    <p><RichText value={faq.a} /></p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        )}
        <section className="area-block">
          <h2>Related <span>pages</span></h2>
          <div className="area-nearby">
            {guide.links.map((item) => (
              <Link key={item.href + item.label} to={item.href} className="area-chip">{item.label}</Link>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default GuidePage;
